<div class="container-form">
  @if (logoColorPath()) {
    <img [src]="isMobile ? logoColorPath() : logoWhitePath()" alt="Icono" class="icon"/>
  }
  <div class="box-form">
    <ng-content></ng-content>
  </div>
</div>
